(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const displayScaleMap = { editorial: 0.85, display: 1, loud: 1.18 };
  const setDisplayScale = () => {
    const mode = document.documentElement.dataset.typeScale || 'display';
    document.documentElement.style.setProperty('--display-mult', displayScaleMap[mode] || 1);
  };

  const setupReveal = () => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => entry.isIntersecting && entry.target.classList.add('is-visible')),
      { threshold: 0.15 }
    );
    const observe = (root) => $$('.reveal', root).forEach((el) => observer.observe(el));
    observe(document);
    // Watch for elements added dynamically (React prototype renders after this script runs)
    new MutationObserver((mutations) => {
      mutations.forEach((m) => m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.classList?.contains('reveal')) observer.observe(node);
        $$('.reveal', node).forEach((el) => observer.observe(el));
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  const setupMobileNav = () => {
    const toggle = $('[data-mobile-nav-toggle]');
    const panel = $('#stedee-mobile-nav');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });
  };

  const setupProductTopbar = () => {
    const topbar = $('[data-product-topbar]');
    const heroAtc = $('[data-hero-atc]');
    if (!topbar || !heroAtc) return;

    const observer = new IntersectionObserver(([entry]) => {
      topbar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.15 });

    observer.observe(heroAtc);
  };

  const setupStickyBuyBar = () => {
    const bar = $('[data-sticky-buy]');
    const heroAtc = $('[data-hero-atc]');
    if (!bar || !heroAtc) return;

    const observer = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.2 });

    observer.observe(heroAtc);
  };

  const openCart = () => {
    $('[data-cart-drawer]')?.classList.add('is-open');
    $('[data-cart-overlay]')?.classList.add('is-open');
  };

  const closeCart = () => {
    $('[data-cart-drawer]')?.classList.remove('is-open');
    $('[data-cart-overlay]')?.classList.remove('is-open');
  };

  const cartAdd = (formData) => fetch('/cart/add.js', {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: formData,
  }).then((r) => r.json());

  const refreshCartCount = () => fetch('/cart.js').then((r) => r.json()).then((cart) => {
    const count = cart.item_count;
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count === 0 ? 'none' : '';
    });
    $$('[data-cart-open]').forEach((btn) => {
      btn.setAttribute('aria-label', `Open cart (${count} item${count === 1 ? '' : 's'})`);
    });
  }).catch(() => {});

  const setupCartEvents = () => {
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-open]')) openCart();
      if (event.target.closest('[data-cart-close]')) closeCart();
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;
      if (event._stedeeHandled) return;
      event.preventDefault();
      const payload = new FormData(form);
      await cartAdd(payload);
      await refreshCartCount();
      if (typeof window.refreshCartDrawer === 'function') {
        window.refreshCartDrawer();
      }
      openCart();
    });
  };

  const setupReviewFilter = () => {
    const select = $('[data-review-filter]');
    if (!select) return;

    select.addEventListener('change', () => {
      const rating = select.value;
      $$('[data-review-rating]').forEach((card) => {
        const match = rating === 'all' || card.dataset.reviewRating === rating;
        card.hidden = !match;
      });
    });
  };

  const setupBeforeAfter = () => {
    $$('[data-before-after-slider]').forEach((slider) => {
      slider.addEventListener('input', () => {
        slider.closest('[data-before-after]')?.style.setProperty('--before-after', `${slider.value}%`);
      });
    });
  };

  setDisplayScale();
  setupReveal();
  setupMobileNav();
  setupProductTopbar();
  setupStickyBuyBar();
  setupCartEvents();
  setupReviewFilter();
  setupBeforeAfter();
})();
